import { getTemplateNavHeaderStyles } from "../NavHeader-Level1/NavHeader-Level1.styles"

const t = document.createElement('template')
t.innerHTML = `
<div class="navheader-utility">
  <slot></slot>
</div>
`
class NavHeaderLevel1Utility extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
  }
}

if (!customElements.get('ts-navheader-level1-utility')) {
  customElements.define('ts-navheader-level1-utility', NavHeaderLevel1Utility)
}
export { NavHeaderLevel1Utility }